import Button from './button'
import Facebook from '../assets/fb.png'
import Instagram from '../assets/instagram.png'
import React, { useState } from 'react'
import Youtube from '../assets/yt.png'
import brandlogos from '../assets/brand.png'
import logoGrey from '../assets/logo-grey.svg'
import linkedIn from '../assets/linkedin.svg'
import { Link } from 'react-router-dom'
import { routes } from 'routes'
import { useCreateFeedbackMutation } from 'services/feedback.service'
import { useHandleApiResponse } from 'hooks'
import { alert, validate } from 'utilities'

const Footer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  })
  const [errors, setErrors] = useState({})

  const [createFeedback, { isLoading: isSubmitting, ...response }] = useCreateFeedbackMutation()

  const handleSuccess = () => {
    alert.success('Thank you for your feedback! We will get back to you soon.')
    setFormData({ name: '', email: '', message: '' })
    setErrors({})
  }

  useHandleApiResponse({ ...response, handleSuccess })

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required'
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Name must be at least 2 characters'
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (!/^[^\s]+@[^\s]+\.[^\s]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email'
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required'
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters'
    }

    return newErrors
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const validationErrors = validateForm()
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
      return
    }

    createFeedback(formData)
  }

  return (
    <div className='bg-[#22242A] flex flex-col md:flex-row md:justify-evenly wrapper' id='contactus'>
      {/* <div className='flex bg-[#22242A] text-white'> */}
      <div className='w-full bg-[#17181C] mt-16 rounded-lg shadow-lg py-8 px-6 md:w-[392px] md:my-16'>
        <p className='text-[#BF5540] text-xs font-medium'>FEEDBACK</p>
        <p className='text-[#FFFFFF66] text-base sm:text-3xl font-normal mt-10'>Have Something to Say?</p>
        <p className='text-white text-base sm:text-3xl font-normal mb-8'>Send us a message</p>
        <form onSubmit={handleSubmit}>
          <div className='mb-4'>
            <input
              type='text'
              name='name'
              placeholder='Name'
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              className={`text-xs w-full py-2 px-4 text-white bg-[#17181C] border-solid border rounded-lg focus:outline-none sm:text-sm ${
                errors.name ? 'border-red-500 focus:border-red-500' : 'border-[#FFFFFF3D] focus:border-[#FFFFFF99]'
              }`}
            />
            {errors.name && <p className='text-red-400 text-xs mt-1'>{errors.name}</p>}
          </div>
          <div className='mb-4'>
            <input
              type='email'
              name='email'
              placeholder='Email'
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              className={`bg-[#17181C] text-white border border-solid rounded-lg focus:outline-none text-xs w-full py-2 px-4 sm:text-sm ${
                errors.email ? 'border-red-500 focus:border-red-500' : 'border-[#FFFFFF3D] focus:border-[#FFFFFF99]'
              }`}
            />
            {errors.email && <p className='text-red-400 text-xs mt-1'>{errors.email}</p>}
          </div>
          <div className='mb-4'>
            <textarea
              name='message'
              placeholder='Your Message'
              rows='4'
              value={formData.message}
              onChange={(e) => handleInputChange('message', e.target.value)}
              className={`text-xs text-white w-full py-2 px-4 bg-[#17181C] border rounded-lg focus:outline-none sm:text-sm ${
                errors.message ? 'border-red-500 focus:border-red-500' : 'border-[#FFFFFF3D] focus:border-[#FFFFFF99]'
              }`}
            />
            {errors.message && <p className='text-red-400 text-xs mt-1'>{errors.message}</p>}
          </div>
          <Button
            className='text-xs hover:bg-opacity-90 transition duration-300 mt-5 sm:text-sm'
            type='submit'
            isLoading={isSubmitting}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </Button>
        </form>
        <p className='text-[#FFFFFF66]  text-xs font-normal mt-40'>Privacy</p>
      </div>
      {/* </div> */}
      <div>
        <div className='w-full my-8 md:w-[704px] py-8 px-6 md:my-16'>
          <div className='flex flex-row justify-between align-top '>
            <div className='flex flex-col'>
              <p className='text-[#BF5540] text-xs font-medium mb-6'>INFO</p>
              <Link to={routes.home} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                Home
              </Link>

              <Link to={routes.programs.home} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                Programs
              </Link>

              <Link to={routes.about} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                About Us
              </Link>

              <Link to={routes.gallery} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                Gallery
              </Link>

              <Link to={routes.admin.login} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                Login as admin
              </Link>
            </div>

            <div className='flex flex-col'>
              <p className='text-[#BF5540] text-xs font-medium mb-6'>ABOUT US</p>
              <Link to={routes.gallery} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                Gallery
              </Link>
              <Link to={routes.about} className='text-xs cursor-pointer text-[#FFFFFF66] sm:text-sm font-normal mb-2 hover:text-[#BF5540]'>
                About Us
              </Link>
            </div>
            <img className='hidden h-20 w-auto sm:h-20 sm:flex sm:w-auto' src={logoGrey} alt='imgglogo'></img>
          </div>

          <div className='flex flex-col mt-14'>
            <p className='text-[#BF5540] text-xs font-medium mb-6'>CONTACT US</p>
            <a href='tel:+18138347991' className='text-xs text-[#FFFFFF66] sm:text-sm font-normal mb-2'>
              Mobile 1: +1 813 834 7991
            </a>

            <p className='text-xs text-[#FFFFFF66] sm:text-sm font-normal mb-2'>Florida, USA</p>
            <a href='tel:+18138347991' className='text-xs text-[#FFFFFF66] sm:text-sm font-normal mb-2'>
              Mobile 2: +234 813 678 7263
            </a>
            <p className='text-xs text-[#FFFFFF66] sm:text-sm font-normal mb-2'>Lagos, Nigeria</p>
          </div>
          <a href='mailto:Info@hillemissaries.com' className='text-xs text-[#FFFFFF66] sm:text-sm font-normal cursor-pointer mb-2'>
            Info@hillemissaries.com
          </a>
          <div className='mt-14'>
            {/* <p className='text-[#BF5540] text-xs font-medium mb-6'>SUBSCRIPTION</p>
            <div className='pb-10'>
              <input
                type='email'
                placeholder='Email'
                className='text-xs w-full text-white py-2 px-4 bg-[#17181C] border border-solid border-[#FFFFFF3D] rounded-lg focus:outline-none focus:border-[#FFFFFF99] sm:text-sm'
              />
            </div> */}

            <div className='flex flex-col items-center sm:flex-row md:align-bottom sm:justify-between mt-40'>
              <div className='flex items-center space-x-4'>
                <a href='https://www.facebook.com/profile.php?id=61563027965675&mibextid=LQQJ4d' target='_blank' rel='noopener noreferrer'>
                  {' '}
                  <div className='w-10 h-10 flex items-center justify-center rounded-full border border-text-[#FFFFFF66] cursor-pointer'>
                    <img src={Facebook} alt='Facebook' className='w-4 h-4 ' />
                  </div>
                </a>
                <a href='https://www.instagram.com/thehillemissaries/' target='_blank' rel='noopener noreferrer'>
                  {' '}
                  <div className='w-10 h-10 flex items-center justify-center rounded-full border bordertext-[#FFFFFF66] cursor-pointer'>
                    <img src={Instagram} alt='Instagram' className='w-4 h-4' />
                  </div>
                </a>
                <a href='https://www.youtube.com/@TheHillEmissaries' target='_blank' rel='noopener noreferrer'>
                  {' '}
                  <div className='w-10 h-10 flex items-center justify-center rounded-full border border-text-[#FFFFFF66] cursor-pointer'>
                    <img src={Youtube} alt='Youtube' className='w-4 h-4' />
                  </div>
                </a>
                <a
                  href='https://www.linkedin.com/search/results/all/?fetchDeterministicClustersOnly=true&heroEntityKey=urn%3Ali%3Aorganization%3A105398736&keywords=the%20hill%20emissaries&origin=RICH_QUERY_SUGGESTION&position=0&searchId=fe5e6a16-fcf5-4e61-ad82-619cd6b96450&sid=PQc&spellCorrectionEnabled=false'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {' '}
                  <div className='w-10 h-10 flex items-center justify-center rounded-full border border-text-[#FFFFFF66] cursor-pointer'>
                    <img src={linkedIn} alt='Twitter' className='w-4 h-4' />
                  </div>
                </a>
              </div>
              <p className='text-xs sm:text-sm text-[#FFFFFF66] mt-8 sm:0 '>© {new Date().getFullYear()} — Copyright</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
